function numberFormat(value: number, minimumFractionDigits = 2, maximumFractionDigits = 2) {
  return new Intl.NumberFormat('en-UK', {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value)
}

export { numberFormat }
